import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import HexLinkBackground from './HexLinkBackground';


interface HexLinkProps{
  children: object | string,
  isGrid?: boolean,
}

const WhiteHexLink = ({ children, isGrid = false, ...otherProps }: HexLinkProps) => {
  const data = useStaticQuery(graphql`
    query {
      redButtonSvg: file(name: { eq: "whiteHex" }) {
        publicURL
      }
    }
  `);

  return (
    <HexLinkBackground
      isGrid={isGrid}
      backgroundimage={data.redButtonSvg.publicURL}
      {...otherProps}
    >
      <span className="redButtonTitle">
        {children}
      </span>
    </HexLinkBackground>
  );
};


export default WhiteHexLink;
